"use client";

import { useState } from "react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { memoCoursesType } from "@/interFace/courses/types";

import "bootstrap-icons/font/bootstrap-icons.css";

import PaginationControls from "./Pagination/PaginationControls";
//import PaginationGrid from "./Pagination/PaginationGrid";
import PaginationList from "./Pagination/PaginationList";
import PaginationHeader from "./Pagination/PaginationHeader";

interface MainProps {
  data: memoCoursesType[];
  locale: string;
}

const CoursePagination: React.FC<MainProps> =  ({ locale, data }) => {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();
  const page = Number(searchParams.get("page")) || 1;
  const paginationParams = new URLSearchParams(searchParams.toString());
  paginationParams.delete("page");
  const basePath = paginationParams.toString()
    ? `${pathname || `/${locale}/quizzes`}?${paginationParams.toString()}`
    : pathname || `/${locale}/quizzes`;
  const [currentPage, setCurrentPage] = useState(page);
  const [viewType, setViewType] = useState<"list" | "grid">("list");
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const totalPages = Math.ceil(data.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedData = data.slice(startIndex, endIndex);

  return (
    <>
      <PaginationHeader
        setView={setViewType}
        setNumber={setItemsPerPage}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        viewType={viewType}
        totalItems={data.length}
      />
      <div className="row">
        <div className="col-xxl-12">
          <div className="course__tab-conent">
            <div className="tab-content" id="courseTabContent">
              {viewType === "grid" ? (
                //<PaginationGrid data={paginatedData} />
                <span></span>
              ) : (
                <PaginationList data={paginatedData} locale={locale} />
              )}
            </div>
          </div>
        </div>
      </div>
      <PaginationControls
        router={router}
        currentPage={currentPage}
        page={page}
        totalPages={totalPages}
        basePath={basePath}
        setPage={setCurrentPage}
      />
    </>
  );
};

export default CoursePagination;
